import urlQS from '@/utils/urlQS';

const loadScript = callback => {
  const didiSdkUrl = '//static.udache.com/common/trinity-login/2.3.0/login.min.js'
  const passportSdkScript = document.createElement('script')
  passportSdkScript.src = didiSdkUrl;
  passportSdkScript.onload = () => {
    callback()
  }
  document.body.appendChild(passportSdkScript)
}

const loginByPassportSDK = async () => {
  const { passportAppId, passportRole } = urlQS.parse(location.href)
  return new Promise((resolve) => {
    loadScript(() => {
      window.login.setConfig({
        appid: +passportAppId,
        role: +passportRole,
        showProtocol: false,
        auto_fill_phone: false,
        phonePage: {
          subTitle: '为了向您提供该功能并保护用户个人信息，需要获取您的手机号用于身份验证'
        },
      })

      window.login.forceLogin(({ ticket }) => {
        resolve(ticket)
      });
    })
  })
}

export {
  loadScript,
  loginByPassportSDK,
}